import { effect, Injectable, signal } from '@angular/core';
import { Alert } from '../../schemas/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  public alert = signal<Alert | null>(null);
  alertEffect = effect(() => {
    if (this.alert() !== null && this.currentTimeOut) {
      clearTimeout(this.currentTimeOut);
      this.currentTimeOut = null;
    }
  });
  currentTimeOut: any = null;

  constructor() {}

  clearMessages() {
    this.clearAlertAfterDelay();
    // this.alert.set(null);
  }

  private clearAlertAfterDelay(): void {
    const alertDelay = this.alert()?.delay ? this.alert()!.delay - 1000 : 4000;
    this.currentTimeOut = setTimeout(() => {
      this.alert.set(null);
    }, alertDelay);
  }
}
